import { Button } from "@mui/material";
import PropTypes from "prop-types";
import { trackEventBeforeNavigation } from "../configureMixpanel";

export default function LogOutButton({ children = null, sx = {}, source = "header", ...rest }) {
  LogOutButton.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object,
    source: PropTypes.string,
  };

  const requestToLogout = () => {
    trackEventBeforeNavigation("logout_clicked", { source });
    window.location.href = "/logout/";
  };

  return (
    <Button
      variant="outlined"
      color="inherit"
      sx={{
        fontWeight: 600,
        "&:hover": {
          backgroundColor: "grey.600",
          borderColor: "grey.600",
        },
        ...sx,
      }}
      {...rest}
      onClick={requestToLogout}
    >
      {children ?? "Log out"}
    </Button>
  );
}
